import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter, Link } from "react-router-dom";

class EventUMA_test extends Component {
  componentDidMount = () => {
    window.addEventListener("message", this._addr);
  };

  _addr = (e) => {
    const idx = e.data.idx;
    console.log("test..." + idx);
  };
  _open = () => {
    window.open(
      "https://shop.aniplustv.com/popAddr",
      "addr",
      "width=500, height=600"
    );
  };

  render() {
    return <div onClick={this._open}>주소창 열기</div>;
  }
}

export default shopContext(withRouter(EventUMA_test));
